"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_instantsearch_dom_1 = require("react-instantsearch-dom");
function Autocomplete(_a) {
    var hits = _a.hits, currentRefinement = _a.currentRefinement, refine = _a.refine;
    var _b = react_1.useState(false), hasFocus = _b[0], setHasFocus = _b[1];
    return (react_1.default.createElement("div", { className: "relative mr-4" },
        react_1.default.createElement("input", { className: 'form-input w-full', type: "search", name: "query", placeholder: window.__('Gemeente, provincie of postcode'), value: currentRefinement, onChange: function (event) { return refine(event.currentTarget.value); }, onFocus: function () { return setHasFocus(true); }, onBlur: function () { return setTimeout(function () { setHasFocus(false); }, 100); }, autoComplete: 'off' }),
        react_1.default.createElement("ul", { className: "mt-1 absolute bg-white border-gray-100 border shadow-xl divide-y divide-gray-100" }, hasFocus && currentRefinement && hits.map(function (hit) { return (react_1.default.createElement("li", { key: hit.objectID },
            react_1.default.createElement("a", { className: "block px-4 py-2 hover:bg-gray-100", href: hit.url }, hit.title))); }))));
}
exports.default = react_instantsearch_dom_1.connectAutoComplete(Autocomplete);
